
import FilaNotas from '../../../../Utiles/Prototipos/Fila/Notas';
export default class FilaCredito extends FilaNotas {
    constructor(p: any) {
        super(p);
        this.label = 'NOTA DE CREDITO EN COMPRA';
        this.parent = 'COMPRA';
    }
}